import LoadingPage from '@/common/pages/LoadingPage';
import BranchRateImage from '@/modules/Statistics/assets/icons/branch-rate.svg?react';
import CountryRateImage from '@/modules/Statistics/assets/icons/country-rate.svg?react';
import { useQuery } from '@tanstack/react-query';
import { Box } from 'styled-system/jsx';
import { getAdjusterRankChartQueryOptions } from '../../queries/getAdjusterRankChart/getAdjusterRankChartQueryOptions';
import { getAdjusterRankpositionQueryOptions } from '../../queries/getAdjusterRankposition/getAdjusterRankpositionQueryOptions';
import { getEvaluationSummaryQueryOptions } from '../../queries/getEvaluationSummary/getEvaluationSummaryQueryOptions';
import RankingCard from '../card/RankingCard';
import GaugeChart from '../charts/GaugeChart';
import RateChartSection from './RateChartSection';
import { RateSectionProps } from './RateSection.type';

export default function StatisticRateSection({
  countryRankRef,
}: RateSectionProps) {
  const { data, isPending } = useQuery(getAdjusterRankpositionQueryOptions());

  const { data: AdjusterChartData, isPending: AdjusterChartPending } = useQuery(
    getAdjusterRankChartQueryOptions(),
  );

  const { data: AdjusterGaugeChartData } = useQuery(
    getEvaluationSummaryQueryOptions({ user_type: 'adjuster' }),
  );

  return (
    <Box>
      <GaugeChart
        value={Number(AdjusterGaugeChartData?.performance ?? 0)}
        totalFiles={AdjusterGaugeChartData?.total_files ?? 0}
        startRange={0}
        EndRange={5}
      />

      <Box
        display="flex"
        flexDirection="column"
        gap="10px"
        ref={countryRankRef}
      >
        {isPending ? (
          <LoadingPage height="20vh" />
        ) : (
          <>
            <RankingCard
              rank={data?.national_rank}
              label="رتبه کشوری"
              totalAssessors={data?.national_adjusters}
              themeColor="purple"
              icon={<CountryRateImage />}
            />
            <RankingCard
              rank={data?.province_rank}
              label="رتبه در استان"
              totalAssessors={data?.province_adjusters}
              themeColor="blue"
              icon={<BranchRateImage />}
            />
          </>
        )}
        {AdjusterChartPending ? (
          <LoadingPage height="30vh" />
        ) : (
          <RateChartSection AdjusterChartData={AdjusterChartData ?? []} />
        )}
      </Box>
    </Box>
  );
}
